import React, { Component,Fragment } from 'react'

import UAParser from 'ua-parser-js'

import imgDefaultLogo from '../../images/public/company_empty.png'
import imgEmailSend from '../../images/public/IMG_EMAIL_SEND.png'
import imgAstrntFooter from '../../images/public/logo-astronaut.svg'
import { t } from "../../helpers/global";
import isEmpty from 'lodash/isEmpty'

class ReceivedAplication extends Component {
	constructor(props) {
		super(props)
		
	}

	

	render() {
		const {
			customColor,
      backgroundImage,
      company,
      imageOnError,
      job,
      show_due_date,
      dueDate,
			renderTime,
			isEmpty,
			translations,
			candidate_name,
		} = this.props

		
		return(
			<Fragment>
			{
				customColor=='' ?
				<div/>
				:
				<Fragment>
				 <div>
					<header className="header-career" style={{background:"url("+backgroundImage+")"+customColor}} >
						<div className={`container ${backgroundImage=='' || backgroundImage==null || backgroundImage==0? '': 'invisible'}`}>
							<div className="flex-container img-container m-r-10 float-align-left">
								<a href={company.website}
									className="text-white"
									target="_blank"
									rel="noopener noreferrer">
									<img
										className="company-logo img-responsive"
										src={company.logoUrl}
										alt={company.title}
										onError={imageOnError} />
								</a>
							</div>
							<div className="header-detail vertical-item--center flex-between float-align-right text-right">
								<div>
									<h3 className="heading3 m-b-5">{company.title} - {job.title}</h3>
									<p className="font-16">{!isEmpty(job.jobType) ? <span>{job.jobType}</span>: '' }{!isEmpty(job.due_date) ? <span className="m-l-10">{show_due_date==1?<Fragment>&bull;&nbsp;&nbsp;{t(translations, "LABEL_DUE_DATE")}</Fragment>:''} <b>{show_due_date==1?dueDate:''} {show_due_date?renderTime(job):''}</b></span>: '' }</p>
								</div>
							</div>
						</div>
					</header>
					<section className="p-t-40 p-b-24 bg-gray" id="multidocupload-form">
						<div className="container" style={{maxWidth: '622px'}}>
							<div className="row">
								<div className="col-sm-12 col-md-12">
											<section id="section-registration" className="registration" style={{padding: '24px 70px 32px'}}>
												<div className='text-center div-finish-upload'>
													<img className='m-b-25' src={imgEmailSend} alt="" />
													<h1>{t(translations, "RECEIVED_APPLICATION_LANDING_PAGE")}</h1>
													<p>
													{t(translations, "GREETINGS_LANDING_PAGE", {
														":candidate_name": candidate_name
													})}
													</p>
													<br/>
													

													<p>{t(translations, "THANKYOU_INTERESTED_1_LANDING_PAGE")} <br/>
													{t(translations, "THANKYOU_INTERESTED_2_LANDING_PAGE", {
														":company_name": company.title
													})}
													</p>
												</div>
											</section>
									
								</div>
							</div>
						</div>
					</section>
					<div className="footer-astrnt">
									<section>
											Powered by <a><img src={imgAstrntFooter} /></a> All Rights Reserved.
									</section>
							</div>
			
				</div>
				</Fragment>
			}
			</Fragment>

		)
	}
}


export default ReceivedAplication;
